import { render } from "./CosmoNewSettings.vue?vue&type=template&id=592179d3&scoped=true"
import script from "./CosmoNewSettings.vue?vue&type=script&lang=js"
export * from "./CosmoNewSettings.vue?vue&type=script&lang=js"

import "./CosmoNewSettings.vue?vue&type=style&index=0&id=592179d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592179d3"]])

export default __exports__